import { render, staticRenderFns } from "./Item5.vue?vue&type=template&id=5d99f09a&scoped=true&"
import script from "./Item5.vue?vue&type=script&lang=js&"
export * from "./Item5.vue?vue&type=script&lang=js&"
import style0 from "./Item5.vue?vue&type=style&index=0&id=5d99f09a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d99f09a",
  null
  
)

export default component.exports